import {
    PCS_Commands_MAIN,
    PCS_Faults_MAIN,
    PCS_Status_MAIN,
    PCS_Faults_PSM1,
    PCS_Status_PSM1,
    PCS_Commands_Ovr_PSM1,
    PCS_Faults_PSM2,
    PCS_Status_PSM2,
    PCS_Commands_Ovr_PSM2,
    PCS_Faults_PSM3,
    PCS_Status_PSM3,
    PCS_Commands_Ovr_PSM3,
    PCS_Faults_PSM4,
    PCS_Status_PSM4,
    PCS_Commands_Ovr_PSM4,
    PCS_Faults_PSM5,
    PCS_Status_PSM5,
    PCS_Commands_Ovr_PSM5,

    Fuel_Prop_COMMON,
    Fuel_Prop_PSM1,
    Fuel_Prop_PSM2,
    Fuel_Prop_PSM3,
    Fuel_Prop_PSM4,
    Fuel_Prop_PSM5,

    PCS_Overview_S300_MAIN,
    TMS_Overview_S300_MAIN,
    CVS_Overview_Main,
    PCS_Overview_S300_PSM1,
    CVS_Overview_S300_PSM1,
    PSM_Overview_S300_PSM1,
    Stack_Overview_S300_PSM1,
    PCS_Overview_S300_PSM2,
    CVS_Overview_S300_PSM2,
    PSM_Overview_S300_PSM2,
    Stack_Overview_S300_PSM2,
    PCS_Overview_S300_PSM3,
    CVS_Overview_S300_PSM3,
    PSM_Overview_S300_PSM3,
    Stack_Overview_S300_PSM3,
    PCS_Overview_S300_PSM4,
    CVS_Overview_S300_PSM4,
    PSM_Overview_S300_PSM4,
    Stack_Overview_S300_PSM4,
    PCS_Overview_S300_PSM5,
    CVS_Overview_S300_PSM5,
    PSM_Overview_S300_PSM5,
    Stack_Overview_S300_PSM5,
    Plant_Overview_COMMON,

    Events_log,
    Events_log_PSM1,
    Events_log_PSM2,
    Events_log_PSM3,
    Events_log_PSM4,
    Events_log_PSM5,
    App_Settings,
    Live_Charts,

    Water_Treatment_MAIN,
    Cabinet_Cooling_MAIN,
    AOGR_Flow_PSM1,
    AOGR_Inlet_Temp_PSM1,
    Current_Limiting_Device_PSM1,
    Process_Air_PSM1,
    Process_Fuel_PSM1,
    Start_Burner_Flow_PSM1,
    Power_Dispatch_PSM1,
    AOGR_Blower_Motor_PSM1,
    Cabinet_Temp_PSM1,
    Cathode_Anode_PSM1,
    AOGR_Flow_PSM2,
    AOGR_Inlet_Temp_PSM2,
    Current_Limiting_Device_PSM2,
    Process_Air_PSM2,
    Process_Fuel_PSM2,
    Start_Burner_Flow_PSM2,
    Power_Dispatch_PSM2,
    AOGR_Blower_Motor_PSM2,
    Cabinet_Temp_PSM2,
    Cathode_Anode_PSM2,
    AOGR_Flow_PSM3,
    AOGR_Inlet_Temp_PSM3,
    Current_Limiting_Device_PSM3,
    Process_Air_PSM3,
    Process_Fuel_PSM3,
    Start_Burner_Flow_PSM3,
    Power_Dispatch_PSM3,
    AOGR_Blower_Motor_PSM3,
    Cabinet_Temp_PSM3,
    Cathode_Anode_PSM3,
    AOGR_Flow_PSM4,
    AOGR_Inlet_Temp_PSM4,
    Current_Limiting_Device_PSM4,
    Process_Air_PSM4,
    Process_Fuel_PSM4,
    Start_Burner_Flow_PSM4,
    Power_Dispatch_PSM4,
    AOGR_Blower_Motor_PSM4,
    Cabinet_Temp_PSM4,
    Cathode_Anode_PSM4,
    AOGR_Flow_PSM5,
    AOGR_Inlet_Temp_PSM5,
    Current_Limiting_Device_PSM5,
    Process_Air_PSM5,
    Process_Fuel_PSM5,
    Start_Burner_Flow_PSM5,
    Power_Dispatch_PSM5,
    AOGR_Blower_Motor_PSM5,
    Cabinet_Temp_PSM5,
    Cathode_Anode_PSM5,

    Analog_IO_MAIN,
    Digital_IO_MAIN,
    Analog_IO_PSM1,
    Digital_IO_PSM1,
    Analog_IO_PSM2,
    Digital_IO_PSM2,
    Analog_IO_PSM3,
    Digital_IO_PSM3,
    Analog_IO_PSM4,
    Digital_IO_PSM4,
    Analog_IO_PSM5,
    Digital_IO_PSM5,

    Calibration_IO_MAIN,
    Calibration_IO_PSM1,
    Calibration_IO_PSM2,
    Calibration_IO_PSM3,
    Calibration_IO_PSM4,
    Calibration_IO_PSM5,
    VSD_FB_MAIN,
    VSD_FB_PSM1,
    VSD_FB_PSM2,
    VSD_FB_PSM3,
    VSD_FB_PSM4,
    VSD_FB_PSM5,

    Powerplant_Operation_MAIN,
    Pre_StartIO_MAIN,
    Powerplant_Operation_PSM1,
    Pre_StartIO_PSM1,
    Powerplant_Operation_PSM2,
    Pre_StartIO_PSM2,
    Powerplant_Operation_PSM3,
    Pre_StartIO_PSM3,
    Powerplant_Operation_PSM4,
    Pre_StartIO_PSM4,
    Powerplant_Operation_PSM5,
    Pre_StartIO_PSM5,

    Calc_Parm_MAIN,
    Calc_Parm_PSM1,
    Calc_Parm_PSM2,
    Calc_Parm_PSM3,
    Calc_Parm_PSM4,
    Calc_Parm_PSM5,
    Inter_locks_MAIN,
    Inter_locks_PSM1,
    Inter_locks_PSM2,
    Inter_locks_PSM3,
    Inter_locks_PSM4,
    Inter_locks_PSM5,
    Seq_Override_MAIN,
    Seq_Override_PSM1,
    Seq_Override_PSM2,
    Seq_Override_PSM3,
    Seq_Override_PSM4,
    Seq_Override_PSM5,

    Model_Activation_MAIN,
    Model_Activation_PSM1,
    Model_Activation_PSM2,
    Model_Activation_PSM3,
    Model_Activation_PSM4,
    Model_Activation_PSM5,
    Parameter_Reset_MAIN,
    Parameter_Reset_PSM1,
    Parameter_Reset_PSM2,
    Parameter_Reset_PSM3,
    Parameter_Reset_PSM4,
    Parameter_Reset_PSM5,

    AL_Alarms_MAIN,
    AL_Shutdowns_MAIN,
    AL_Alarms_PSM1,
    AL_Shutdowns_PSM1,
    AL_Alarms_PSM2,
    AL_Shutdowns_PSM2,
    AL_Alarms_PSM3,
    AL_Shutdowns_PSM3,
    AL_Alarms_PSM4,
    AL_Shutdowns_PSM4,
    AL_Alarms_PSM5,
    AL_Shutdowns_PSM5,

    Retune_File_MAIN,
    Retune_File_PSM1,
    Retune_File_PSM2,
    Retune_File_PSM3,
    Retune_File_PSM4,
    Retune_File_PSM5,

    SVM_IO_MAIN,
    PSM_IO_MAIN,
    CommFault_Overview_COMMON,
    Sound_Settings, Shortcut_Guide


} from "./constants/pages";

import PCSCommandsMAIN from "./components/Displays/PCS/PCSMAIN/PCSCommandsMAIN";
import PCSFaultsMAIN from "./components/Displays/PCS/PCSMAIN/PCSFaultsMAIN";
import PCSStatusMAIN from "./components/Displays/PCS/PCSMAIN/PCSStatusMAIN";

import PCSCommandsPSM1 from "./components/Displays/PCS/PCSPSM1/PCSCommandsPSM1";
import PCSCommandsOvrPSM1 from "./components/Displays/PCS/PCSPSM1/PCSCommandsOvrPSM1";
import PCSFaultsPSM1 from "./components/Displays/PCS/PCSPSM1/PCSFaultsPSM1";
import PCSStatusPSM1 from "./components/Displays/PCS/PCSPSM1/PCSStatusPSM1";

import PCSCommandsPSM2 from "./components/Displays/PCS/PCSPSM2/PCSCommandsPSM2";
import PCSCommandsOvrPSM2 from "./components/Displays/PCS/PCSPSM2/PCSCommandsOvrPSM2";
import PCSFaultsPSM2 from "./components/Displays/PCS/PCSPSM2/PCSFaultsPSM2";
import PCSStatusPSM2 from "./components/Displays/PCS/PCSPSM2/PCSStatusPSM2";

import PCSCommandsPSM3 from "./components/Displays/PCS/PCSPSM3/PCSCommandsPSM3";
import PCSCommandsOvrPSM3 from "./components/Displays/PCS/PCSPSM3/PCSCommandsOvrPSM3";
import PCSFaultsPSM3 from "./components/Displays/PCS/PCSPSM3/PCSFaultsPSM3";
import PCSStatusPSM3 from "./components/Displays/PCS/PCSPSM3/PCSStatusPSM3";

import PCSCommandsPSM4 from "./components/Displays/PCS/PCSPSM4/PCSCommandsPSM4";
import PCSCommandsOvrPSM4 from "./components/Displays/PCS/PCSPSM4/PCSCommandsOvrPSM4";
import PCSFaultsPSM4 from "./components/Displays/PCS/PCSPSM4/PCSFaultsPSM4";
import PCSStatusPSM4 from "./components/Displays/PCS/PCSPSM4/PCSStatusPSM4";

import PCSCommandsPSM5 from "./components/Displays/PCS/PCSPSM5/PCSCommandsPSM5";
import PCSCommandsOvrPSM5 from "./components/Displays/PCS/PCSPSM5/PCSCommandsOvrPSM5";
import PCSFaultsPSM5 from "./components/Displays/PCS/PCSPSM5/PCSFaultsPSM5";
import PCSStatusPSM5 from "./components/Displays/PCS/PCSPSM5/PCSStatusPSM5";

import FuelProperties from "./components/Displays/SystemSetting/FuelProperties";
import FuelPropertiesPSM1 from "./components/Displays/SystemSetting/FuelPropertiesPSM1";
import FuelPropertiesPSM2 from "./components/Displays/SystemSetting/FuelPropertiesPSM2";
import FuelPropertiesPSM3 from "./components/Displays/SystemSetting/FuelPropertiesPSM3";
import FuelPropertiesPSM4 from "./components/Displays/SystemSetting/FuelPropertiesPSM4";
import FuelPropertiesPSM5 from "./components/Displays/SystemSetting/FuelPropertiesPSM5";

import Alarms_MAIN from "./components/Displays/Alarms/Alarms_MAIN/Alarms_MAIN";
import Alarms_PSM1 from "./components/Displays/Alarms/Alarms_PSM1/Alarms_PSM1";
import Alarms_PSM2 from "./components/Displays/Alarms/Alarms_PSM2/Alarms_PSM2";
import Alarms_PSM3 from "./components/Displays/Alarms/Alarms_PSM3/Alarms_PSM3";
import Alarms_PSM4 from "./components/Displays/Alarms/Alarms_PSM4/Alarms_PSM4";
import Alarms_PSM5 from "./components/Displays/Alarms/Alarms_PSM5/Alarms_PSM5";

import Shutdown_MAIN from "./components/Displays/Shutdown/Shutdown_MAIN/Shutdown_MAIN";
import Shutdown_PSM1 from "./components/Displays/Shutdown/Shutdown_PSM1/Shutdown_PSM1";
import Shutdown_PSM2 from "./components/Displays/Shutdown/Shutdown_PSM2/Shutdown_PSM2";
import Shutdown_PSM3 from "./components/Displays/Shutdown/Shutdown_PSM3/Shutdown_PSM3";
import Shutdown_PSM4 from "./components/Displays/Shutdown/Shutdown_PSM4/Shutdown_PSM4";
import Shutdown_PSM5 from "./components/Displays/Shutdown/Shutdown_PSM5/Shutdown_PSM5";

import CalibrationIO_MAIN from "./components/Displays/Calibration/Calibration_Main/CalibrationIO_MAIN";
import CalibrationIO_PSM1 from "./components/Displays/Calibration/Calibration_PSM1/CalibrationIO_PSM1";
import CalibrationIO_PSM2 from "./components/Displays/Calibration/Calibration_PSM2/CalibrationIO_PSM2";
import CalibrationIO_PSM3 from "./components/Displays/Calibration/Calibration_PSM3/CalibrationIO_PSM3";
import CalibrationIO_PSM4 from "./components/Displays/Calibration/Calibration_PSM4/CalibrationIO_PSM4";
import CalibrationIO_PSM5 from "./components/Displays/Calibration/Calibration_PSM5/CalibrationIO_PSM5";

import IOCheckMacro_MAIN from "./components/Displays/Operations/Operations_MAIN/IOCheckMacro_MAIN";
import IOCheckMacro_PSM1 from "./components/Displays/Operations/Operations_PSM1/IOCheckMacro_PSM1";
import IOCheckMacro_PSM2 from "./components/Displays/Operations/Operations_PSM2/IOCheckMacro_PSM2";
import IOCheckMacro_PSM3 from "./components/Displays/Operations/Operations_PSM3/IOCheckMacro_PSM3";
import IOCheckMacro_PSM4 from "./components/Displays/Operations/Operations_PSM4/IOCheckMacro_PSM4";
import IOCheckMacro_PSM5 from "./components/Displays/Operations/Operations_PSM5/IOCheckMacro_PSM5";

import EventHistory from "./components/Displays/Operations/EventHistory";
//update separate eventHistory page
import EventHistory_PSM1 from "./components/Displays/Operations/EventHistoryPSM1";
import EventHistory_PSM2 from "./components/Displays/Operations/EventHistoryPSM2";
import EventHistory_PSM3 from "./components/Displays/Operations/EventHistoryPSM3";
import EventHistory_PSM4 from "./components/Displays/Operations/EventHistoryPSM4";
import EventHistory_PSM5 from "./components/Displays/Operations/EventHistoryPSM5";
import AppSettings from "./components/Displays/AppSetting/AppSettings";

//update 220822
import LiveCharts from "./components/Displays/Operations/LiveCharts";
import PlantOvrCOMMON from "./components/Displays/SystemOverview/PlantOvrCOMMON";
import CommFaultOvrCOMMON from "./components/Displays/SystemOverview/CommFaultOvrCOMMON";

// @ Overview
//update for SOFC
import TMSOvr_S300_MAIN from "./components/Displays/SystemOverview/S300SystemOverview/TMSOvr_S300_MAIN";
import PCSOvr_S300_MAIN from "./components/Displays/SystemOverview/S300SystemOverview/PCSOvr_S300_MAIN";

import PSMOvr_S300_PSM1 from "./components/Displays/SystemOverview/S300SystemOverview/PSMOvr_S300_PSM1";
import PCSOvr_S300_PSM1 from "./components/Displays/SystemOverview/S300SystemOverview/PCSOvr_S300_PSM1";
import CVSOvr_S300_PSM1 from "./components/Displays/SystemOverview/S300SystemOverview//CVSOvr_S300_PSM1";
import StackOvr_S300_PSM1 from "./components/Displays/SystemOverview/S300SystemOverview/StackOvr_S300_PSM1";

import PSMOvr_S300_PSM2 from "./components/Displays/SystemOverview/S300SystemOverview/PSMOvr_S300_PSM2";
import PCSOvr_S300_PSM2 from "./components/Displays/SystemOverview/S300SystemOverview/PCSOvr_S300_PSM2";
import CVSOvr_S300_PSM2 from "./components/Displays/SystemOverview/S300SystemOverview//CVSOvr_S300_PSM2";
import StackOvr_S300_PSM2 from "./components/Displays/SystemOverview/S300SystemOverview/StackOvr_S300_PSM2";

import PSMOvr_S300_PSM3 from "./components/Displays/SystemOverview/S300SystemOverview/PSMOvr_S300_PSM3";
import PCSOvr_S300_PSM3 from "./components/Displays/SystemOverview/S300SystemOverview/PCSOvr_S300_PSM3";
import CVSOvr_S300_PSM3 from "./components/Displays/SystemOverview/S300SystemOverview//CVSOvr_S300_PSM3";
import StackOvr_S300_PSM3 from "./components/Displays/SystemOverview/S300SystemOverview/StackOvr_S300_PSM3";

import PSMOvr_S300_PSM4 from "./components/Displays/SystemOverview/S300SystemOverview/PSMOvr_S300_PSM4";
import PCSOvr_S300_PSM4 from "./components/Displays/SystemOverview/S300SystemOverview/PCSOvr_S300_PSM4";
import CVSOvr_S300_PSM4 from "./components/Displays/SystemOverview/S300SystemOverview//CVSOvr_S300_PSM4";
import StackOvr_S300_PSM4 from "./components/Displays/SystemOverview/S300SystemOverview/StackOvr_S300_PSM4";

import PSMOvr_S300_PSM5 from "./components/Displays/SystemOverview/S300SystemOverview/PSMOvr_S300_PSM5";
import PCSOvr_S300_PSM5 from "./components/Displays/SystemOverview/S300SystemOverview/PCSOvr_S300_PSM5";
import CVSOvr_S300_PSM5 from "./components/Displays/SystemOverview/S300SystemOverview/CVSOvr_S300_PSM5";
import StackOvr_S300_PSM5 from "./components/Displays/SystemOverview/S300SystemOverview/StackOvr_S300_PSM5";


import AnalogIo_MAIN from "./components/Displays/IO/IOMain/AnalogIo_MAIN";
import DigitalIo_MAIN from "./components/Displays/IO/IOMain/DigitalIo_MAIN";

import AnalogIo_PSM1 from "./components/Displays/IO/IOPSM1/AnalogIo_PSM1";
import DigitalIo_PSM1 from "./components/Displays/IO/IOPSM1/DigitalIo_PSM1";
import AnalogIo_PSM2 from "./components/Displays/IO/IOPSM2/AnalogIo_PSM2";
import DigitalIo_PSM2 from "./components/Displays/IO/IOPSM2/DigitalIo_PSM2";
import AnalogIo_PSM3 from "./components/Displays/IO/IOPSM3/AnalogIo_PSM3";
import DigitalIo_PSM3 from "./components/Displays/IO/IOPSM3/DigitalIo_PSM3";
import AnalogIo_PSM4 from "./components/Displays/IO/IOPSM4/AnalogIo_PSM4";
import DigitalIo_PSM4 from "./components/Displays/IO/IOPSM4/DigitalIo_PSM4";
import AnalogIo_PSM5 from "./components/Displays/IO/IOPSM5/AnalogIo_PSM5";
import DigitalIo_PSM5 from "./components/Displays/IO/IOPSM5/DigitalIo_PSM5";

import VSDFBMAIN from "./components/Displays/IO/VSDFBMAIN";
import VSDFBPSM1 from "./components/Displays/IO/VSDFBPSM1";
import VSDFBPSM2 from "./components/Displays/IO/VSDFBPSM2";
import VSDFBPSM3 from "./components/Displays/IO/VSDFBPSM3";
import VSDFBPSM4 from "./components/Displays/IO/VSDFBPSM4";
import VSDFBPSM5 from "./components/Displays/IO/VSDFBPSM5";

import TurboBlowerIo_MAIN from "./components/Displays/IO/TurboBlowerIo_MAIN";

import PPOperations_MAIN from "./components/Displays/Operations/Operations_MAIN/PPOperations_MAIN";
import PPOperations_PSM1 from "./components/Displays/Operations/Operations_PSM1/PPOperations_PSM1";
import PPOperations_PSM2 from "./components/Displays/Operations/Operations_PSM2/PPOperations_PSM2";
import PPOperations_PSM3 from "./components/Displays/Operations/Operations_PSM3/PPOperations_PSM3";
import PPOperations_PSM4 from "./components/Displays/Operations/Operations_PSM4/PPOperations_PSM4";
import PPOperations_PSM5 from "./components/Displays/Operations/Operations_PSM5/PPOperations_PSM5";

import AOGRFlowPSM1 from "./components/Displays/ControlLoopsPSM1/AOGRFlowPSM1";
import AOGRInletTempPSM1 from "./components/Displays/ControlLoopsPSM1/AOGRInletTempPSM1";
import CurrentLimitingDevicePSM1 from "./components/Displays/ControlLoopsPSM1/CurrentLimitingDevicePSM1";
import PowerDispatchPSM1 from "./components/Displays/ControlLoopsPSM1/PowerDispatchPSM1";
import ProcessAirPSM1 from "./components/Displays/ControlLoopsPSM1/ProcessAirFlowPSM1/ProcessAirPSM1";
import ProcessFuelPSM1 from "./components/Displays/ControlLoopsPSM1/ProcessFuelFlowPSM1/ProcessFuelPSM1";
import StartBurnerFlowPSM1 from "./components/Displays/ControlLoopsPSM1/StartBurnerFlowPSM1";

import AOGRBlowerMotor_PSM2 from "./components/Displays/ControlLoopsPSM2/AOGRBlowerMotorPSM2";
import AOGRBlowerMotor_PSM5 from "./components/Displays/ControlLoopsPSM5/AOGRBlowerMotorPSM5";
import AOGRBlowerMotor_PSM3 from "./components/Displays/ControlLoopsPSM3/AOGRBlowerMotorPSM3";
import AOGRBlowerMotor_PSM4 from "./components/Displays/ControlLoopsPSM4/AOGRBlowerMotorPSM4";
import AOGRBlowerMotor_PSM1 from "./components/Displays/ControlLoopsPSM1/AOGRBlowerMotorPSM1";
import CabinetTempPSM5 from "./components/Displays/ControlLoopsPSM5/CabinetTempPSM5";
import CabinetTempPSM4 from "./components/Displays/ControlLoopsPSM4/CabinetTempPSM4";
import CabinetTempPSM3 from "./components/Displays/ControlLoopsPSM3/CabinetTempPSM3";
import CabinetTempPSM2 from "./components/Displays/ControlLoopsPSM2/CabinetTempPSM2";
import CabinetTempPSM1 from "./components/Displays/ControlLoopsPSM1/CabinetTempPSM1";
import CathodeAnodePurgePSM1 from "./components/Displays/ControlLoopsPSM1/CathodeAnodePurgePSM1";
import CathodeAnodePurgePSM2 from "./components/Displays/ControlLoopsPSM2/CathodeAnodePurgePSM2";
import CathodeAnodePurgePSM3 from "./components/Displays/ControlLoopsPSM3/CathodeAnodePurgePSM3";
import CathodeAnodePurgePSM4 from "./components/Displays/ControlLoopsPSM4/CathodeAnodePurgePSM4";
import CathodeAnodePurgePSM5 from "./components/Displays/ControlLoopsPSM5/CathodeAnodePurgePSM5";


import AOGRFlowPSM2 from "./components/Displays/ControlLoopsPSM2/AOGRFlowPSM2";
import AOGRInletTempPSM2 from "./components/Displays/ControlLoopsPSM2/AOGRInletTempPSM2";
import CurrentLimitingDevicePSM2 from "./components/Displays/ControlLoopsPSM2/CurrentLimitingDevicePSM2";
import PowerDispatchPSM2 from "./components/Displays/ControlLoopsPSM2/PowerDispatchPSM2";
import ProcessAirPSM2 from "./components/Displays/ControlLoopsPSM2/ProcessAirFlowPSM2/ProcessAirPSM2";
import ProcessFuelPSM2 from "./components/Displays/ControlLoopsPSM2/ProcessFuelFlowPSM2/ProcessFuelPSM2";
import StartBurnerFlowPSM2 from "./components/Displays/ControlLoopsPSM2/StartBurnerFlowPSM2";


import AOGRFlowPSM3 from "./components/Displays/ControlLoopsPSM3/AOGRFlowPSM3";
import AOGRInletTempPSM3 from "./components/Displays/ControlLoopsPSM3/AOGRInletTempPSM3";
import CurrentLimitingDevicePSM3 from "./components/Displays/ControlLoopsPSM3/CurrentLimitingDevicePSM3";
import PowerDispatchPSM3 from "./components/Displays/ControlLoopsPSM3/PowerDispatchPSM3";
import ProcessAirPSM3 from "./components/Displays/ControlLoopsPSM3/ProcessAirFlowPSM3/ProcessAirPSM3";
import ProcessFuelPSM3 from "./components/Displays/ControlLoopsPSM3/ProcessFuelFlowPSM3/ProcessFuelPSM3";
import StartBurnerFlowPSM3 from "./components/Displays/ControlLoopsPSM3/StartBurnerFlowPSM3";


import AOGRFlowPSM4 from "./components/Displays/ControlLoopsPSM4/AOGRFlowPSM4";
import AOGRInletTempPSM4 from "./components/Displays/ControlLoopsPSM4/AOGRInletTempPSM4";
import CurrentLimitingDevicePSM4 from "./components/Displays/ControlLoopsPSM4/CurrentLimitingDevicePSM4";
import PowerDispatchPSM4 from "./components/Displays/ControlLoopsPSM4/PowerDispatchPSM4";
import ProcessAirPSM4 from "./components/Displays/ControlLoopsPSM4/ProcessAirFlowPSM4/ProcessAirPSM4";
import ProcessFuelPSM4 from "./components/Displays/ControlLoopsPSM4/ProcessFuelFlowPSM4/ProcessFuelPSM4";
import StartBurnerFlowPSM4 from "./components/Displays/ControlLoopsPSM4/StartBurnerFlowPSM4";


import AOGRFlowPSM5 from "./components/Displays/ControlLoopsPSM5/AOGRFlowPSM5";
import AOGRInletTempPSM5 from "./components/Displays/ControlLoopsPSM5/AOGRInletTempPSM5";
import CurrentLimitingDevicePSM5 from "./components/Displays/ControlLoopsPSM5/CurrentLimitingDevicePSM5";
import PowerDispatchPSM5 from "./components/Displays/ControlLoopsPSM5/PowerDispatchPSM5";
import ProcessAirPSM5 from "./components/Displays/ControlLoopsPSM5/ProcessAirFlowPSM5/ProcessAirPSM5";
import ProcessFuelPSM5 from "./components/Displays/ControlLoopsPSM5/ProcessFuelFlowPSM5/ProcessFuelPSM5";
import StartBurnerFlowPSM5 from "./components/Displays/ControlLoopsPSM5/StartBurnerFlowPSM5";


import WaterTreatmentMAIN from "./components/Displays/ControlLoopsMAIN/WaterTreatmentMAIN";
import CabinetCoolingMAIN from "./components/Displays/ControlLoopsMAIN/CabinetCoolingMAIN";

// @ CalcParms 
import CalcParm_MAIN from "./components/Displays/CalcParms/CalcParms_MAIN/CalcParm_MAIN";
import CalcParm_PSM1 from "./components/Displays/CalcParms/CalcParms_PSM1/CalcParm_PSM1";
import CalcParm_PSM2 from "./components/Displays/CalcParms/CalcParms_PSM2/CalcParm_PSM2";
import CalcParm_PSM3 from "./components/Displays/CalcParms/CalcParms_PSM3/CalcParm_PSM3";
import CalcParm_PSM4 from "./components/Displays/CalcParms/CalcParms_PSM4/CalcParm_PSM4";
import CalcParm_PSM5 from "./components/Displays/CalcParms/CalcParms_PSM5/CalcParm_PSM5";

// @ Interlocks
import Interlocks_MAIN from "./components/Displays/Interlocks/Interlocks_MAIN/Interlocks_MAIN";
import Interlocks_PSM1 from "./components/Displays/Interlocks/Interlocks_PSM1/Interlocks_PSM1";
import Interlocks_PSM2 from "./components/Displays/Interlocks/Interlocks_PSM2/Interlocks_PSM2";
import Interlocks_PSM3 from "./components/Displays/Interlocks/Interlocks_PSM3/Interlocks_PSM3";
import Interlocks_PSM4 from "./components/Displays/Interlocks/Interlocks_PSM4/Interlocks_PSM4";
import Interlocks_PSM5 from "./components/Displays/Interlocks/Interlocks_PSM5/Interlocks_PSM5";

// @ SeaOverride
import SeqOverride_MAIN from "./components/Displays/SeqOverride_MAIN";
import SeqOverride_PSM1 from "./components/Displays/SeqOverride_PSM1";
import SeqOverride_PSM2 from "./components/Displays/SeqOverride_PSM2";
import SeqOverride_PSM3 from "./components/Displays/SeqOverride_PSM3";
import SeqOverride_PSM4 from "./components/Displays/SeqOverride_PSM4";
import SeqOverride_PSM5 from "./components/Displays/SeqOverride_PSM5";
//@ System Menu
import ModelActivation_MAIN from "./components/Displays/SystemSetting/ModelActivation_MAIN";
import ModelActivation_PSM1 from "./components/Displays/SystemSetting/ModelActivation_PSM1";
import ModelActivation_PSM2 from "./components/Displays/SystemSetting/ModelActivation_PSM2";
import ModelActivation_PSM3 from "./components/Displays/SystemSetting/ModelActivation_PSM3";
import ModelActivation_PSM4 from "./components/Displays/SystemSetting/ModelActivation_PSM4";
import ModelActivation_PSM5 from "./components/Displays/SystemSetting/ModelActivation_PSM5";

import ParameterReset_MAIN from "./components/Displays/SystemSetting/ParameterReset_MAIN/ParameterReset_MAIN";
import ParameterReset_PSM1 from "./components/Displays/SystemSetting/ParameterReset_PSM1/ParameterReset_PSM1";
import ParameterReset_PSM2 from "./components/Displays/SystemSetting/ParameterReset_PSM2/ParameterReset_PSM2";
import ParameterReset_PSM3 from "./components/Displays/SystemSetting/ParameterReset_PSM3/ParameterReset_PSM3";
import ParameterReset_PSM4 from "./components/Displays/SystemSetting/ParameterReset_PSM4/ParameterReset_PSM4";
import ParameterReset_PSM5 from "./components/Displays/SystemSetting/ParameterReset_PSM5/ParameterReset_PSM5";

import Retune_MAIN from "./components/Displays/PPLT Maintenance/Retune_MAIN";
import Retune_PSM1 from "./components/Displays/PPLT Maintenance/Retune_PSM1";
import Retune_PSM2 from "./components/Displays/PPLT Maintenance/Retune_PSM2";
import Retune_PSM3 from "./components/Displays/PPLT Maintenance/Retune_PSM3";
import Retune_PSM4 from "./components/Displays/PPLT Maintenance/Retune_PSM4";
import Retune_PSM5 from "./components/Displays/PPLT Maintenance/Retune_PSM5";

import SVMIO from "./components/Displays/IO/SVMIO";
// @ S300
import SVMIO_PSM1 from "./components/Displays/IO/SVMIO_PSM1";
import PSMIO_MAIN from "./components/Displays/IO/IOMain/PSMIO_MAIN";
import SoundSettings from "./components/Displays/AppSetting/SoundSettings";
import ShortcutGuide from "./components/Displays/AppSetting/ShortcutGuide";

// ! 순서대로 입력
const RouteList_S300TS = () => {
    const routes = [];
    if(routes.length === 0) {
        routes.push(
            //@ OVERVIEW
            //^ Common : System Overview***********************************
            {page: Plant_Overview_COMMON, component: PlantOvrCOMMON},
            {page: CommFault_Overview_COMMON, component: CommFaultOvrCOMMON},
            //^ MAIN : System Overview***********************************
            // {page: TMS_Overview_S300_MAIN, component: TMSOvr_S300_MAIN},
            {page: PCS_Overview_S300_MAIN, component: PCSOvr_S300_MAIN},
            //^ PSM1 : System Overview***********************************
            {page: CVS_Overview_S300_PSM1, component: CVSOvr_S300_PSM1},
            {page: Stack_Overview_S300_PSM1, component: StackOvr_S300_PSM1},
            {page: PCS_Overview_S300_PSM1, component: PCSOvr_S300_PSM1},
            {page: PSM_Overview_S300_PSM1, component: PSMOvr_S300_PSM1},
            //^ PSM2 : System Overview***********************************
            {page: CVS_Overview_S300_PSM2, component: CVSOvr_S300_PSM2},
            {page: Stack_Overview_S300_PSM2, component: StackOvr_S300_PSM2},
            {page: PCS_Overview_S300_PSM2, component: PCSOvr_S300_PSM2},
            {page: PSM_Overview_S300_PSM2, component: PSMOvr_S300_PSM2},
            //^ PSM3 : System Overview***********************************
            {page: CVS_Overview_S300_PSM3, component: CVSOvr_S300_PSM3},
            {page: Stack_Overview_S300_PSM3, component: StackOvr_S300_PSM3},
            {page: PCS_Overview_S300_PSM3, component: PCSOvr_S300_PSM3},
            {page: PSM_Overview_S300_PSM3, component: PSMOvr_S300_PSM3},
            //^ PSM4 : System Overview***********************************
            {page: CVS_Overview_S300_PSM4, component: CVSOvr_S300_PSM4},
            {page: Stack_Overview_S300_PSM4, component: StackOvr_S300_PSM4},
            {page: PCS_Overview_S300_PSM4, component: PCSOvr_S300_PSM4},
            {page: PSM_Overview_S300_PSM4, component: PSMOvr_S300_PSM4},
            //^ PSM5 : System Overview***********************************
            {page: CVS_Overview_S300_PSM5, component: CVSOvr_S300_PSM5},
            {page: Stack_Overview_S300_PSM5, component: StackOvr_S300_PSM5},
            {page: PCS_Overview_S300_PSM5, component: PCSOvr_S300_PSM5},
            {page: PSM_Overview_S300_PSM5, component: PSMOvr_S300_PSM5},

            //@ Operation
            //^ MAIN : Operations****************************************
            {page: Powerplant_Operation_MAIN, component: PPOperations_MAIN},
            {page: Events_log, component: EventHistory},
            {page: Pre_StartIO_MAIN, component: IOCheckMacro_MAIN},
            //^ COMMON : Operations**************************************
            {page: Live_Charts, component: LiveCharts},
            //^ PSM1 : Operations****************************************
            {page: Powerplant_Operation_PSM1, component: PPOperations_PSM1},
            {page: Pre_StartIO_PSM1, component: IOCheckMacro_PSM1},
            {page: Events_log_PSM1, component: EventHistory_PSM1},
             //^ PSM2 : Operations****************************************
            {page: Powerplant_Operation_PSM2, component: PPOperations_PSM2},
            {page: Pre_StartIO_PSM2, component: IOCheckMacro_PSM2},
            {page: Events_log_PSM2, component: EventHistory_PSM2},
            //^ PSM3 : Operations****************************************
            {page: Powerplant_Operation_PSM3, component: PPOperations_PSM3},
            {page: Pre_StartIO_PSM3, component: IOCheckMacro_PSM3},
            {page: Events_log_PSM3, component: EventHistory_PSM3},
            //^ PSM4 : Operations****************************************
            {page: Powerplant_Operation_PSM4, component: PPOperations_PSM4},
            {page: Pre_StartIO_PSM4, component: IOCheckMacro_PSM4},
            {page: Events_log_PSM4, component: EventHistory_PSM4},
            //^ PSM5 : Operations****************************************
            {page: Powerplant_Operation_PSM5, component: PPOperations_PSM5},
            {page: Pre_StartIO_PSM5, component: IOCheckMacro_PSM5},
            {page: Events_log_PSM5, component: EventHistory_PSM5},

            //@ IO
            // ^ COMMON : IO ********************************************
            // {page: VSD_FB, component: VSDFB},
            // ^ MAIN : IO **********************************************
            {page: Analog_IO_MAIN, component: AnalogIo_MAIN},
            {page: Digital_IO_MAIN, component: DigitalIo_MAIN},
            {page: VSD_FB_MAIN, component: VSDFBMAIN},
            {page: SVM_IO_MAIN, component: SVMIO},
            {page: PSM_IO_MAIN, component: PSMIO_MAIN},
            // ^ PSM1 : IO **********************************************
            {page: Analog_IO_PSM1, component: AnalogIo_PSM1},
            {page: Digital_IO_PSM1, component: DigitalIo_PSM1},
            {page: VSD_FB_PSM1, component: VSDFBPSM1},
            // {page: SVM_IO_PSM1, component: SVMIO_PSM1},
            // ^ PSM2 : IO **********************************************
            {page: Analog_IO_PSM2, component: AnalogIo_PSM2},
            {page: Digital_IO_PSM2, component: DigitalIo_PSM2},
            {page: VSD_FB_PSM2, component: VSDFBPSM2},
            // ^ PSM3 : IO **********************************************
            {page: Analog_IO_PSM3, component: AnalogIo_PSM3},
            {page: Digital_IO_PSM3, component: DigitalIo_PSM3},
            {page: VSD_FB_PSM3, component: VSDFBPSM3},
            // ^ PSM4 : IO **********************************************
            {page: Analog_IO_PSM4, component: AnalogIo_PSM4},
            {page: Digital_IO_PSM4, component: DigitalIo_PSM4},
            {page: VSD_FB_PSM4, component: VSDFBPSM4},
            // ^ PSM5 : IO **********************************************
            {page: Analog_IO_PSM5, component: AnalogIo_PSM5},
            {page: Digital_IO_PSM5, component: DigitalIo_PSM5},
            {page: VSD_FB_PSM5, component: VSDFBPSM5},

            //@ IO Calibration
            {page: Calibration_IO_MAIN, component: CalibrationIO_MAIN},
            {page: Calibration_IO_PSM1, component: CalibrationIO_PSM1},
            {page: Calibration_IO_PSM2, component: CalibrationIO_PSM2},
            {page: Calibration_IO_PSM3, component: CalibrationIO_PSM3},
            {page: Calibration_IO_PSM4, component: CalibrationIO_PSM4},
            {page: Calibration_IO_PSM5, component: CalibrationIO_PSM5},

            //@ Control Loops
            // ^ MAIN Control Loops
            {page: Water_Treatment_MAIN, component: WaterTreatmentMAIN},
            {page: Cabinet_Cooling_MAIN, component: CabinetCoolingMAIN},
            // ^ PSM1 Control Loops
            {page: AOGR_Flow_PSM1, component: AOGRFlowPSM1},
            // {page: AOGR_Inlet_Temp_PSM1, component: AOGRInletTempPSM1},
            {page: Current_Limiting_Device_PSM1, component: CurrentLimitingDevicePSM1},
            {page: Power_Dispatch_PSM1, component: PowerDispatchPSM1},
            {page: Process_Air_PSM1, component: ProcessAirPSM1},
            {page: Process_Fuel_PSM1, component: ProcessFuelPSM1},
            {page: Start_Burner_Flow_PSM1, component: StartBurnerFlowPSM1},
            {page: AOGR_Blower_Motor_PSM1, component: AOGRBlowerMotor_PSM1},
            {page: Cabinet_Temp_PSM1, component: CabinetTempPSM1},
            {page: Cathode_Anode_PSM1, component: CathodeAnodePurgePSM1},
            // ^ PSM2 Control Loops
            {page: AOGR_Flow_PSM2, component: AOGRFlowPSM2},
            // {page: AOGR_Inlet_Temp_PSM2, component: AOGRInletTempPSM2},
            {page: Current_Limiting_Device_PSM2, component: CurrentLimitingDevicePSM2},
            {page: Power_Dispatch_PSM2, component: PowerDispatchPSM2},
            {page: Process_Air_PSM2, component: ProcessAirPSM2},
            {page: Process_Fuel_PSM2, component: ProcessFuelPSM2},
            {page: Start_Burner_Flow_PSM2, component: StartBurnerFlowPSM2},
            {page: AOGR_Blower_Motor_PSM2, component: AOGRBlowerMotor_PSM2},
            {page: Cabinet_Temp_PSM2, component: CabinetTempPSM2},
            {page: Cathode_Anode_PSM2, component: CathodeAnodePurgePSM2},
            // ^ PSM3 Control Loops
            {page: AOGR_Flow_PSM3, component: AOGRFlowPSM3},
            // {page: AOGR_Inlet_Temp_PSM3, component: AOGRInletTempPSM3},
            {page: Current_Limiting_Device_PSM3, component: CurrentLimitingDevicePSM3},
            {page: Power_Dispatch_PSM3, component: PowerDispatchPSM3},
            {page: Process_Air_PSM3, component: ProcessAirPSM3},
            {page: Process_Fuel_PSM3, component: ProcessFuelPSM3},
            {page: Start_Burner_Flow_PSM3, component: StartBurnerFlowPSM3},
            {page: AOGR_Blower_Motor_PSM3, component: AOGRBlowerMotor_PSM3},
            {page: Cabinet_Temp_PSM3, component: CabinetTempPSM3},
            {page: Cathode_Anode_PSM3, component: CathodeAnodePurgePSM3},
            // ^ PSM4 Control Loops
            {page: AOGR_Flow_PSM4, component: AOGRFlowPSM4},
            // {page: AOGR_Inlet_Temp_PSM4, component: AOGRInletTempPSM4},
            {page: Current_Limiting_Device_PSM4, component: CurrentLimitingDevicePSM4},
            {page: Power_Dispatch_PSM4, component: PowerDispatchPSM4},
            {page: Process_Air_PSM4, component: ProcessAirPSM4},
            {page: Process_Fuel_PSM4, component: ProcessFuelPSM4},
            {page: Start_Burner_Flow_PSM4, component: StartBurnerFlowPSM4},
            {page: AOGR_Blower_Motor_PSM4, component: AOGRBlowerMotor_PSM4},
            {page: Cabinet_Temp_PSM4, component: CabinetTempPSM4},
            {page: Cathode_Anode_PSM4, component: CathodeAnodePurgePSM4},
            // ^ PSM5 Control Loops
            {page: AOGR_Flow_PSM5, component: AOGRFlowPSM5},
            // {page: AOGR_Inlet_Temp_PSM5, component: AOGRInletTempPSM5},
            {page: Current_Limiting_Device_PSM5, component: CurrentLimitingDevicePSM5},
            {page: Power_Dispatch_PSM5, component: PowerDispatchPSM5},
            {page: Process_Air_PSM5, component: ProcessAirPSM5},
            {page: Process_Fuel_PSM5, component: ProcessFuelPSM5},
            {page: Start_Burner_Flow_PSM5, component: StartBurnerFlowPSM5},
            {page: AOGR_Blower_Motor_PSM5, component: AOGRBlowerMotor_PSM5},
            {page: Cabinet_Temp_PSM5, component: CabinetTempPSM5},
            {page: Cathode_Anode_PSM5, component: CathodeAnodePurgePSM5},

            //@ Calculated Parameters
            // ^ MAIN : Calculated Parameters *************************
            {page: Calc_Parm_MAIN, component: CalcParm_MAIN},
            // ^ PSM1 : Calculated Parameters *************************
            {page: Calc_Parm_PSM1, component: CalcParm_PSM1},
            // ^ PSM2 : Calculated Parameters *************************
            {page: Calc_Parm_PSM2, component: CalcParm_PSM2},
            // ^ PSM3 : Calculated Parameters *************************
            {page: Calc_Parm_PSM3, component: CalcParm_PSM3},
            // ^ PSM4 : Calculated Parameters *************************
            {page: Calc_Parm_PSM4, component: CalcParm_PSM4},
            // ^ PSM5 : Calculated Parameters *************************
            {page: Calc_Parm_PSM5, component: CalcParm_PSM5},

            //@ Interlocks
            // ^ MAIN : Interlocks ************************************
            {page: Inter_locks_MAIN, component: Interlocks_MAIN},
            // ^ PSM1 : Interlocks ************************************
            {page: Inter_locks_PSM1, component: Interlocks_PSM1},

            // ^ PSM2 : Interlocks ************************************
            {page: Inter_locks_PSM2, component: Interlocks_PSM2},

            // ^ PSM3 : Interlocks ************************************
            {page: Inter_locks_PSM3, component: Interlocks_PSM3},

            // ^ PSM4 : Interlocks ************************************
            {page: Inter_locks_PSM4, component: Interlocks_PSM4},

            // ^ PSM5 : Interlocks ************************************
            {page: Inter_locks_PSM5, component: Interlocks_PSM5},

            //@ PCS
            // TODO : PCS
            // ^ MAIN PCS****************************************************
            {page: PCS_Commands_MAIN, component: PCSCommandsMAIN},
            {page: PCS_Faults_MAIN, component: PCSFaultsMAIN},
            {page: PCS_Status_MAIN, component: PCSStatusMAIN},
            // {page: Power_Monitor_MAIN, component: PowerMonitorMAIN},
            // ^ PSM1 PCS****************************************************
            {page: PCS_Faults_PSM1, component: PCSFaultsPSM1},
            {page: PCS_Status_PSM1, component: PCSStatusPSM1},
            {page: PCS_Commands_Ovr_PSM1, component: PCSCommandsOvrPSM1},
            // ^ PSM2 PCS****************************************************
            {page: PCS_Faults_PSM2, component: PCSFaultsPSM2},
            {page: PCS_Status_PSM2, component: PCSStatusPSM2},
            {page: PCS_Commands_Ovr_PSM2, component: PCSCommandsOvrPSM2},

            // ^ PSM3 PCS****************************************************
            {page: PCS_Faults_PSM3, component: PCSFaultsPSM3},
            {page: PCS_Status_PSM3, component: PCSStatusPSM3},
            {page: PCS_Commands_Ovr_PSM3, component: PCSCommandsOvrPSM3},

            // ^ PSM4 PCS****************************************************
            {page: PCS_Faults_PSM4, component: PCSFaultsPSM4},
            {page: PCS_Status_PSM4, component: PCSStatusPSM4},
            {page: PCS_Commands_Ovr_PSM4, component: PCSCommandsOvrPSM4},

            // ^ PSM5 PCS****************************************************
            {page: PCS_Faults_PSM5, component: PCSFaultsPSM5},
            {page: PCS_Status_PSM5, component: PCSStatusPSM5},
            {page: PCS_Commands_Ovr_PSM5, component: PCSCommandsOvrPSM5},

            //@ Sequence Override
            // ^ MAIN : Sequence Override ************************************
            {page: Seq_Override_MAIN, component: SeqOverride_MAIN},
            // ^ PSM1 : Sequence Override ************************************
            {page: Seq_Override_PSM1, component: SeqOverride_PSM1},
            // ^ PSM2 : Sequence Override ************************************
            {page: Seq_Override_PSM2, component: SeqOverride_PSM2},
            // ^ PSM3 : Sequence Override ************************************
            {page: Seq_Override_PSM3, component: SeqOverride_PSM3},
            // ^ PSM4 : Sequence Override ************************************
            {page: Seq_Override_PSM4, component: SeqOverride_PSM4},
            // ^ PSM5 : Sequence Override ************************************
            {page: Seq_Override_PSM5, component: SeqOverride_PSM5},

            //@ System Menu
            // ^ MAIN : System Menu *****************************************
            {page: Model_Activation_MAIN, component: ModelActivation_MAIN},
            {page: Parameter_Reset_MAIN, component: ParameterReset_MAIN},
            // ^ COMMON : System Menu *****************************************
            // ^ PSM1 : System Menu *****************************************
            {page: Model_Activation_PSM1, component: ModelActivation_PSM1},
            {page: Parameter_Reset_PSM1, component: ParameterReset_PSM1},
            {page: Fuel_Prop_PSM1, component: FuelPropertiesPSM1},
            // ^ PSM2 : System Menu *****************************************
            {page: Model_Activation_PSM2, component: ModelActivation_PSM2},
            {page: Parameter_Reset_PSM2, component: ParameterReset_PSM2},
            {page: Fuel_Prop_PSM2, component: FuelPropertiesPSM2},

            // ^ PSM3 : System Menu *****************************************
            {page: Model_Activation_PSM3, component: ModelActivation_PSM3},
            {page: Parameter_Reset_PSM3, component: ParameterReset_PSM3},
            {page: Fuel_Prop_PSM3, component: FuelPropertiesPSM3},

            // ^ PSM4 : System Menu *****************************************
            {page: Model_Activation_PSM4, component: ModelActivation_PSM4},
            {page: Parameter_Reset_PSM4, component: ParameterReset_PSM4},
            {page: Fuel_Prop_PSM4, component: FuelPropertiesPSM4},

            // ^ PSM5 : System Menu *****************************************
            {page: Model_Activation_PSM5, component: ModelActivation_PSM5},
            {page: Parameter_Reset_PSM5, component: ParameterReset_PSM5},
            {page: Fuel_Prop_PSM5, component: FuelPropertiesPSM5},

            //@ ALSD
            // ^ Main : ALSD ************************************************
            {page: AL_Alarms_MAIN, component: Alarms_MAIN},
            {page: AL_Shutdowns_MAIN, component: Shutdown_MAIN},
            // ^ PSM1 : ALSD ************************************************
            {page: AL_Alarms_PSM1, component: Alarms_PSM1},
            {page: AL_Shutdowns_PSM1, component: Shutdown_PSM1},
            // ^ PSM2 : ALSD ************************************************
            {page: AL_Alarms_PSM2, component: Alarms_PSM2},
            {page: AL_Shutdowns_PSM2, component: Shutdown_PSM2},
            // ^ PSM3 : ALSD ************************************************
            {page: AL_Alarms_PSM3, component: Alarms_PSM3},
            {page: AL_Shutdowns_PSM3, component: Shutdown_PSM3},
            // ^ PSM4 : ALSD ************************************************
            {page: AL_Alarms_PSM4, component: Alarms_PSM4},
            {page: AL_Shutdowns_PSM4, component: Shutdown_PSM4},
            // ^ PSM5 : ALSD ************************************************
            {page: AL_Alarms_PSM5, component: Alarms_PSM5},
            {page: AL_Shutdowns_PSM5, component: Shutdown_PSM5},

            //@ PPLT Maintenance
            // ^ Main : PPLT Maintenance ************************************
            {page: Retune_File_MAIN, component: Retune_MAIN},
            // ^ PSM1 : PPLT Maintenance ************************************
            {page: Retune_File_PSM1, component: Retune_PSM1},
            // ^ PSM2 : PPLT Maintenance ************************************
            {page: Retune_File_PSM2, component: Retune_PSM2},
            // ^ PSM3 : PPLT Maintenance ************************************
            {page: Retune_File_PSM3, component: Retune_PSM3},
            // ^ PSM4 : PPLT Maintenance ************************************
            {page: Retune_File_PSM4, component: Retune_PSM4},
            // ^ PSM5 : PPLT Maintenance ************************************
            {page: Retune_File_PSM5, component: Retune_PSM5},

            //@ APP Settings
            /************************COMMON APP Settings*******************/
            {page: App_Settings, component: AppSettings},
            {page: Sound_Settings, component: SoundSettings},
            {page: Shortcut_Guide, component: ShortcutGuide}
        );
    }
    return routes;
}

export default RouteList_S300TS;
